export const LoadingStatus = {
  NONE: 0,
  FETCHING: 1,
  FETCHED: 2,
  ERROR: 3,
  NEXT_PAGE: 4,
}
